/**
 * What the customer reads when a node or builder refuses a transaction.
 * The raw RPC text ("insufficient fee, rejecting replacement …") stays in
 * telemetry; the screen gets one plain sentence that names the cause and
 * what to do. Unknown messages pass through untouched.
 */
export function friendlyTxError(raw: unknown): string {
	const text = String(
		(raw as any)?.response?.data?.message ?? (raw as any)?.message ?? raw ?? ''
	).trim()
	const lower = text.toLowerCase()
	if (!lower) return 'Something went wrong. Try again.'
	if (
		lower.includes('rejecting replacement') ||
		lower.includes('txn-mempool-conflict') ||
		lower.includes('insufficient fee')
	) {
		return 'A coin here is still settling from your last transaction. Wait for it to confirm, then try again.'
	}
	if (lower.includes('missingorspent') || lower.includes('bad-txns-inputs')) {
		return 'A coin here was already spent. Refresh and try again.'
	}
	if (
		lower.includes('min relay fee') ||
		lower.includes('mempool min fee') ||
		lower.includes('fee too low') ||
		lower.includes('minimum fee')
	) {
		return 'Fee is below what the network accepts right now. Choose a higher fee.'
	}
	if (lower.includes('too-long-mempool-chain') || lower.includes('too many unconfirmed')) {
		return 'Too many unconfirmed transactions in a row. Wait for one to confirm.'
	}
	if (lower.includes('dust')) {
		return 'An amount here is too small to send.'
	}
	if (lower.includes('script-verify') || lower.includes('signature')) {
		return 'The signature was not accepted. Try again.'
	}
	if (lower.startsWith('rpcerror') || lower.includes('code: some(')) {
		return 'The network refused this transaction. Try again in a moment.'
	}
	return text
}
